export const SEND_MINDBOX_AUTH = 'SEND_MINDBOX_AUTH';
export const SEND_MINDBOX_REGISTRATION = 'SEND_MINDBOX_REGISTRATION';
export const SEND_MINDBOX_AUTH_ON_CHECKOUT = 'SEND_MINDBOX_AUTH_ON_CHECKOUT';
export const SEND_MINDBOX_FILL_TOURIST_DATA = 'SEND_MINDBOX_FILL_TOURIST_DATA';
export const SEND_MINDBOX_PAGEVIEW_CHECKOUT = 'SEND_MINDBOX_PAGEVIEW_CHECKOUT';
export const SEND_MINDBOX_PAGEVIEW_HOTEL = 'SEND_MINDBOX_PAGEVIEW_HOTEL';
export const SEND_MINDBOX_PAGEVIEW_EXPLORE = 'SEND_MINDBOX_PAGEVIEW_EXPLORE';
